import { render } from "./TrialActivationSuccess.vue?vue&type=template&id=481aa159"
import script from "./TrialActivationSuccess.vue?vue&type=script&lang=js"
export * from "./TrialActivationSuccess.vue?vue&type=script&lang=js"

import "./TrialActivationSuccess.vue?vue&type=style&index=0&id=481aa159&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__